import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.9277 10.9631C11.9216 12.6326 10.0912 13.7492 7.99991 13.7492C5.90866 13.7492 4.07819 12.6326 3.07214 10.9631",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.9389 5.05553C11.9353 3.37566 10.099 2.25073 7.99993 2.25073C5.90085 2.25073 4.06452 3.37566 3.06091 5.05553",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }